import { Container, Paper, useTheme } from "@mui/material";
import * as React from "react";

import { RobotoIcon } from "@/shared/components";

interface InviteCardProps {
  children: React.ReactNode;
}

export const InviteCard: React.FC<InviteCardProps> = ({ children }) => {
  const theme = useTheme();

  return (
    <Container
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Paper
        sx={{
          padding: theme.spacing(3),
          marginTop: theme.spacing(2),
          minWidth: "400px",
        }}
      >
        <RobotoIcon />

        {children}
      </Paper>
    </Container>
  );
};
